module.exports = __webpack_public_path__ + "static/Eliza1-ca80bc96d01e4819271d34abf58cf411.png";